<section class="mb-air-section">
<iframe
[src]="mbAirUrl"
width="100%"
height="800"
style="border: none;"
></iframe>
</section> 